import { render, staticRenderFns } from "./cascadingFields.vue?vue&type=template&id=135c3923&scoped=true"
import script from "./cascadingFields.vue?vue&type=script&lang=js"
export * from "./cascadingFields.vue?vue&type=script&lang=js"
import style0 from "./cascadingFields.vue?vue&type=style&index=0&id=135c3923&prod&lang=scss"
import style1 from "./cascadingFields.vue?vue&type=style&index=1&id=135c3923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c3923",
  null
  
)

export default component.exports